import {AfterViewInit, Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {merge, of, ReplaySubject} from 'rxjs';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {MatSnackBar} from '@angular/material/snack-bar';
import {FormHelperService} from '../../../../shared/services/form-helper.service';
import {Router} from '@angular/router';
import {delay, first, skipUntil, takeUntil, tap} from 'rxjs/operators';
import {Uuid} from '../../../../shared/interface/response/uuid';
import {HttpErrorResponse} from '@angular/common/http';
import {CommissionRedirection} from '../../../../shared/interface/commission-redirection';
import {CommissionRedirectionService} from '../../../../shared/services/commission-redirection.service';
import moment from 'moment';
import {CommissionRedirectionOfwcaRelations} from '../../../../shared/interface/commission-redirection-ofwca-relations';
import {Contract} from '../../../../shared/interface/contract';
import {formatNumber} from "@angular/common";
export interface PeriodicElement {
  name: string;
  position: number;
  weight: string;
  symbol: string;
}
const ELEMENT_DATA: PeriodicElement[] = [
  {position: 1, name: 'Agro TUW', weight: '13 znaków', symbol: '1004N00071340, 1002N00646450, 1590N00348765'},
  {position: 2, name: 'Allianz', weight: 'od 4 do 8 znaków  (bez 0 na początku numeru) – wpisujemy nr po –', symbol: '3348, 43980, 740352'},
  {position: 3, name: 'Allianz Życie', weight: 'od 4 do 8 znaków (bez 0 na początku numeru)', symbol: '9127606, 90149798'},
  {position: 4, name: 'Compensa', weight: 'od 7 do 9 znaków – wpisujemy nr po / ', symbol: '5162013, 8329145, 4116615, 7993091'},
  {position: 5, name: 'Compensa Życie', weight: 'od 8 do 10 znaków - wpisujemy nr po /', symbol: '5172100870 z pk.5162100173, 1922200334'},
  {position: 6, name: 'Defend', weight: 'od 4 do 6 znaków-6 znaków', symbol: 'PGAFRT-00300460, PGAG-356542, PGMG-239431 '},
  {position: 7, name: 'Ergo Hestia', weight: '12 znaków lub 8 znaków/2 znaki/8 znaków', symbol: '911019672253, WAUG4529/21/KOM00012, 911023819414'},
  {position: null, name: '', weight: '12 znaków', symbol: '460001842633, 460002139960, 460002077335'},
  {position: null, name: '',  weight: ' ', symbol: '909007471275, 922000064217, WAUG2382/21/KOM00163'},
  {position: null, name: '', weight: ' ', symbol: 'WAUG2983/21/KOM/A00094, WAUG1024/78051411791/15/2987, 903013833470'},
  {position: 8, name: 'Ergo Hestia Życie', weight: '6 lub 12 znaków', symbol: 'P24216, 642000000000, 641000000000, P28716'},
  {position: null, name: '', weight: '12 znaków', symbol: 'P08266157916, P08266109945, P08266974874'},
  {position: null, name: '', weight: '12 znaków', symbol: 'P30004242798, P30004711889, P30004167176'},
  {position: 9, name: 'Europ Assistance', weight: ' ', symbol: 'AAM112/03163/10/2022, AAM112/03266/10/2022, T16O/03107/10/2022'},
  {position: 10, name: 'Generali ', weight: ' ', symbol: '50010330773, 80132220286, PO/01014484/2022'},
  {position: null, name: '', weight: ' ', symbol: '25865254, 25859212, 25854051'},
  {position: null, name: '', weight: ' ', symbol: '56004989402, 56004976212, 56005028580'},
  {position: 11, name: 'Generali Życie', weight: ' ', symbol: '10251918, 20218678, 90000030331_1356, 90000026648_441'},
  {position: null, name: '', weight: ' ', symbol: '321217001, 90020013565, 90020013565'},
  {position: 12, name: 'Inter Polska', weight: 'pomiędzy literami a cyframi występuje spacja!', symbol: 'FM_T 219149042, POC_T 211492260, PL_T 193362591, POC_T 211510250'},
  {position: 13, name: 'Inter Polska Życie', weight: '6 znaków', symbol: '118611, 112411, 112409'},
  {position: 14, name: 'InterRisk', weight: 'Na końcu nr wpisujemy %, w przypadku polisy wznawianej z końcówką -A, -AA, -AAA. Usuwamy wszystkie znaki do ""-"" włącznie i zastępujemy je % np. KM-H/P0123456-A wpisujemy KM-H/P0123456%', symbol: 'EDUS-A/P493782, KM-H/P1314579, KE-E/P0116440,'},
  {position: 15, name: 'Link4', weight: '11, 12 lub 14 znaków. Usuwamy ostatni znak, w jego miejsce wpisujemy %', symbol: 'SME30975378400, M27583638502, L4D31109369800, SME30975472600'},
  {position: 16, name: 'PZU', weight: '10 znaków-jeden lub dwa znaki, na końcu polisy używamy %', symbol: '1075347396-1, 1013763963-8, 1075142108-1'},
  {position: 17, name: 'Open Life', weight: '11 lub 12 znaków', symbol: '567690000600, 567690000700'},
  {position: 18, name: 'PZU Życie', weight: ' ', symbol: '810312405/168602233, 709637152, 810313923/195400044'},
  {position: 19, name: 'RESO', weight: ' ', symbol: 'OPL-PA2 1490153, PL22-P190-15548097, PL22-P190-35211765'},
  {position: 20, name: 'Signal Iduna', weight: '6 lub 15 znaków', symbol: 'GPA284335386578'},
  {position: 21, name: 'Signal Iduna Życie', weight: '10 lub 15 znaków', symbol: 'GLM196718800497'},
  {position: 22, name: 'Trasti', weight: '12 znaków', symbol: '100160033840, 100160605030, 100161053260'},
  {position: 23, name: 'TUZ', weight: '10 lub 12 znaków', symbol: 'BPS0063344, KOS1772766, OCS0021922, DMS0302419'},
  {position: 24, name: 'Uniqa', weight: '10 znaków - wpisujemy nr po – (nie wpisujemy roku)', symbol: '1785626091, 1421836651, 802884311, 658513551756/01'},
  {position: 25, name: 'Uniqa Życie', weight: '8 znaków', symbol: '51598702, 62021254, 85009110'},
  {position: 27, name: 'Unum Życie ', weight: '6 znaków', symbol: '523511'},
  {position: 28, name: 'VH', weight: '10 znaków', symbol: '2000022279, 2000022616, 2000022335'},
  {position: 29, name: 'Vienna Life', weight: '10 znaków lub 10 znaków_10 znaków', symbol: 'KP00005271_20220816SU, KP00006181_20221004SZNW, KG00001288'},
  {position: 30, name: 'Warta', weight: '12 znaków', symbol: '920027830684, 920027827963'},
  {position: 31, name: 'Warta Życie', weight: 'wpisujemy numer z pominięciem 0 pomiędzy znakami, np. EP0007539 - EP7539', symbol: 'QW61037, AE1040144, QW253'},
  {position: 32, name: 'Wiener', weight: '9 znaków', symbol: 'TPA074601, 135199592, KPB486170'},
  {position: 33, name: 'AWP', weight: '20 znaków, wpisujemy cały numer z początkiem ASF/CAR/2024/, używając „/”', symbol: 'ASF/CAR/2024/00000562'},
  {position: 34, name: 'EUROINS', weight: '12 znaków, wpisujemy numer z 0 na początku', symbol: '000109306968'},
  {position: 35, name: 'TUW TUW', weight: '10 znaków, na początku wpisujemy %', symbol: '3347498614, 4647561021'},
];
@Component({
  selector: 'app-redirection-add',
  templateUrl: './redirection-add.component.html',
  styleUrls: ['./redirection-add.component.scss']
})
export class RedirectionAddComponent implements OnInit, OnDestroy, AfterViewInit {
  @Input() commissionRedirection?: ReplaySubject<CommissionRedirection>;
  @Output() closeModification = new EventEmitter<any>();

  commissionRedirectionObject?: CommissionRedirection = null;
  processingRequest = false;
  formErrors: any = {};
  commissionRedirectionForm: FormGroup;
  insuranceCompanyControl: FormControl;
  companyControl: FormControl;
  ofwcaControl: FormControl;
  policyNumberControl: FormControl;
  customerNameControl: FormControl;
  concludeDateControl: FormControl;
  newOfwcaControl: FormControl;
  newPartnerControl: FormControl;
  newInsuranceCompanyIdControl: FormControl;
  newPartnerAssetsRegionalControl: FormControl;
  newContractControl: FormControl;
  withoutPolicyNumberControl: FormControl;
  proportionalCommissionControl: FormControl;
  externalOfwcaControl: FormControl;
  showAllContractsControl: FormControl;
  internalCommissionControl: FormControl;
  crossCompanyControl: FormControl;
  assignControl: FormControl;
  commissionRedirectionFormValid = false;
  controlContracts: ReplaySubject<Contract[]> = new ReplaySubject<Contract[]>(1);
  availableContracts: ReplaySubject<Contract[]> = new ReplaySubject<Contract[]>(1);
  allAvailableContracts: ReplaySubject<Contract[]> = new ReplaySubject<Contract[]>(1);
  displayedColumns: string[] = ['position', 'name', 'weight', 'symbol'];
  dataSource = ELEMENT_DATA;

  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);
  private initialized: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  constructor(
    private fb: FormBuilder,
    private snack: MatSnackBar,
    private commissionRedirectionService: CommissionRedirectionService,
    private formHelper: FormHelperService,
    private router: Router,
  ) {
    this.commissionRedirectionForm = this.fb.group({
      insuranceCompany: this.insuranceCompanyControl = fb.control('', [Validators.required]),
      company: this.companyControl = fb.control('', [Validators.required]),
      ofwca: this.ofwcaControl = fb.control('', [Validators.required]),
      policyNumber: this.policyNumberControl = fb.control('', [Validators.required]),
      customerName: this.customerNameControl = fb.control(''),
      concludeDate: this.concludeDateControl = fb.control('', []),
      newOfwca: this.newOfwcaControl = fb.control('', [Validators.required]),
      newPartner: this.newPartnerControl = fb.control(''),
      newInsuranceCompanyId: this.newInsuranceCompanyIdControl = fb.control(''),
      newPartnerAssetsRegional: this.newPartnerAssetsRegionalControl = fb.control(''),
      newContract: this.newContractControl = fb.control('', [Validators.required]),
      withoutPolicyNumber: this.withoutPolicyNumberControl = fb.control(false),
      externalOfwca: this.externalOfwcaControl = fb.control(false),
      showAllContracts: this.showAllContractsControl = fb.control(false),
      internalCommission: this.internalCommissionControl = fb.control(false),
      crossCompany: this.crossCompanyControl = fb.control(false),
      assign: this.assignControl = fb.control(false),
      proportionalCommission: this.proportionalCommissionControl = fb.control(false),
    });
  }

  ngOnInit(): void {
    this.commissionRedirectionForm.valueChanges
      .pipe(
        takeUntil(this.destroyed$),
        delay(0),
        tap(() => this.commissionRedirectionFormValid = this.commissionRedirectionForm.valid)
      )
      .subscribe();


    this.withoutPolicyNumberControl.valueChanges
      .pipe(takeUntil(this.destroyed$))
      .subscribe((withoutPolicyNumber: boolean) => {
        if (withoutPolicyNumber) {
          this.policyNumberControl.disable();
          this.customerNameControl.setValidators([Validators.required]);
        } else {
          this.policyNumberControl.enable();
          this.customerNameControl.setValidators([]);
        }

        this.customerNameControl.updateValueAndValidity();
      });

    this.externalOfwcaControl.valueChanges
      .pipe(takeUntil(this.destroyed$))
      .subscribe((externalOfwca: boolean) => {
        if (externalOfwca) {
          this.ofwcaControl.disable();
        } else {
          this.ofwcaControl.enable();
        }
      });

    this.internalCommissionControl.valueChanges
      .pipe(takeUntil(this.destroyed$))
      .subscribe((internalCommission: boolean) => {
        if (internalCommission) {
          this.newOfwcaControl.disable();
          this.newContractControl.disable();
        } else {
          this.newOfwcaControl.enable();
          this.newContractControl.enable();
        }
      });

    merge(
      this.companyControl.valueChanges,
      this.newOfwcaControl.valueChanges,
      this.crossCompanyControl.valueChanges,
    ).pipe(
      skipUntil(this.initialized),
      takeUntil(this.destroyed$)
    ).subscribe(() => {
      if (!this.companyControl.value || !this.newOfwcaControl.value) {
        return;
      }

      this.loadOfwcaRelations(true);
    });
  }

  loadOfwcaRelations(setNewValues = false): void {
    if (!this.newOfwcaControl.value) {
      return;
    }

    this.commissionRedirectionService.getOfwcaRelationsContract(
      this.companyControl.value,
      this.newOfwcaControl.value,
      this.insuranceCompanyControl.value,
    ).subscribe((ofwcaRelations: CommissionRedirectionOfwcaRelations) => {
      if (setNewValues) {
        this.newPartnerControl.setValue(ofwcaRelations.newPartnerId ?? '');
        this.newPartnerAssetsRegionalControl.setValue(ofwcaRelations.newPartnerAssetsRegionalId ?? '');
        this.newContractControl.setValue(ofwcaRelations.newContractId ?? '');
        this.newInsuranceCompanyIdControl.setValue(ofwcaRelations.newInsuranceCompanyId ?? '');
      }

      this.availableContracts.next(ofwcaRelations.availableContracts);
      this.allAvailableContracts.next(ofwcaRelations.allAvailableContracts);

      if (this.crossCompanyControl.value) {
        this.controlContracts.next(ofwcaRelations.allAvailableContracts);
        this.newContractControl.setValue(ofwcaRelations.altNewContractId);
      } else {
        this.controlContracts.next(ofwcaRelations.availableContracts);
      }
    });
  }

  ngAfterViewInit(): void {
    if (this.commissionRedirection) {
      this.commissionRedirection.pipe(
        first(),
        delay(0)
      )
      .subscribe((commissionRedirection: CommissionRedirection) => {
        this.commissionRedirectionObject = commissionRedirection;
        this.initialize(commissionRedirection);
      });
    } else {
      this.initialized.next(true);
    }
  }
// {{(commissionRedirectionObject.assign === null ? 0 : commissionRedirectionObject.assign) | number:'1.2-2'}} zł
  initialize(commissionRedirection: CommissionRedirection): void {
    of(commissionRedirection)
      .pipe(
        tap(() => {
          this.commissionRedirectionForm.reset({
            insuranceCompany: commissionRedirection.insuranceCompany?.id,
            company: commissionRedirection.company?.id,
            ofwca: commissionRedirection.ofwca?.uuid,
            policyNumber: commissionRedirection.policyNumber,
            customerName: commissionRedirection.customerName,
            concludeDate: commissionRedirection.concludeDate ? moment(commissionRedirection.concludeDate) : '',
            newOfwca: commissionRedirection.newOfwca?.uuid,
            newPartner: commissionRedirection.newPartner?.uuid ?? '',
            newPartnerAssetsRegional: commissionRedirection.newPartnerAssetsRegional?.uuid ?? '',
            newContract: commissionRedirection.newContract?.uuid ?? '',
            withoutPolicyNumber: !commissionRedirection.policyNumber,
            externalOfwca: commissionRedirection.ofwca === null,
            showAllContracts: true,
            internalCommission: !commissionRedirection.newOfwca,
            crossCompany: commissionRedirection.crossCompany,
            assign: commissionRedirection.assign,
            proportionalCommission: commissionRedirection.proportionalCommission
          });
          this.loadOfwcaRelations();
        }),
        delay(0),
        tap(() => {
          this.commissionRedirectionForm.markAllAsTouched();
          this.initialized.next(true);
        })
      ).subscribe();
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  sendForm(): void {
    if (!this.commissionRedirectionForm.valid) {
      this.commissionRedirectionForm.markAllAsTouched();
      this.snack.open('Wypełnij lub popraw wszystkie wymagane pola', '', {
        duration: 2000,
      });
      return;
    }

    this.processingRequest = true;
    this.formHelper.removeBackendErrorState(this.commissionRedirectionForm, this.formErrors);
    this.formErrors = {};

    this.commissionRedirectionService.sendForm(this.commissionRedirectionForm.value, this.commissionRedirectionObject?.uuid)
      .pipe(
        first()
      )
      .subscribe((response: Uuid) => {
        this.snack.open(this.commissionRedirectionObject ? 'Pomyślnie zaktualizowano obiekt'
          : 'Pomyślnie utworzono obiekt', '', {
          duration: 2000,
        });
        this.processingRequest = false;

        if (!this.commissionRedirectionObject) {
          this.router.navigate(['/przepiecia-polis/szczegoly', response.uuid]);
        } else {
          this.closeModification.emit();
        }
      }, (error: HttpErrorResponse) => {
        this.processingRequest = false;

        if (error.status === 404) {
          this.snack.open('Rekord został usunięty lub przeniesiony', error.status.toString(), {
            duration: 2000,
          });
          this.router.navigate(['/przepiecia-polis']);
          return;
        }

        this.snack.open(this.commissionRedirectionObject ? 'Podczas aktualizacji obiektu wystąpił błąd'
          : 'Podczas tworzenia obiektu wystąpił błąd', error.status.toString(), {
          duration: 2000,
        });

        if (error.status === 400) {
          this.formErrors = error.error.error.list;
          this.formHelper.setBackendErrorState(this.commissionRedirectionForm, this.formErrors);
        }
      })
    ;
  }

  cancel(): void {
    if (!this.commissionRedirectionObject) {
      this.router.navigate(['/przepiecia-polis']);
    } else {
      this.closeModification.emit();
    }
  }

}
